<template>
    <DModal
        :show="showModal"
        :title="__('tools.fulfillment.withdrawal_confirm_title')"
        :message="__('tools.fulfillment.withdrawal_confirm_message')"
        is-confirm
        is-error
        @update:show="$emit('update:showModal', $event)"
        @confirm="$emit('confirm-modal', skipEmail)"
        @close="$emit('close-modal')"
    >
        <DCard>
            <DCardBody>
                <DRow>
                    <DCol>
                        <DFormCheck
                            id="skip_email"
                            v-model="skipEmail"
                            :label="__('tools.fulfillment.withdrawal_skip_email')"
                            inline
                        />
                    </DCol>
                </DRow>
            </DCardBody>
        </DCard>
    </DModal>
</template>

<script>
export default {
    name: 'WithdrawContractModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['confirm-modal', 'close-modal', 'update:showModal'],
    data () {
        return {
            skipEmail: false
        }
    }
}
</script>

<style scoped>

</style>
